import { render, staticRenderFns } from "./SupervisedPersonsListModal.vue?vue&type=template&id=22ea13ce&scoped=true"
import script from "./SupervisedPersonsListModal.vue?vue&type=script&lang=js"
export * from "./SupervisedPersonsListModal.vue?vue&type=script&lang=js"
import style0 from "./SupervisedPersonsListModal.vue?vue&type=style&index=0&id=22ea13ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea13ce",
  null
  
)

export default component.exports